import api from './api';

export const getBlogs = async (params = {}) => {
  const res = await api.get('/blogs', { params });
  return res.data;
};

export const getBlog = async (slug) => {
  const res = await api.get(`/blogs/${slug}`);
  return res.data;
};
